import {Box, Tooltip} from "@material-ui/core";
import StarIcon from "@material-ui/icons/Star";
import NumberFormat from "react-number-format";
import React, {useEffect, useState} from "react";
import {useNavStyles} from "./Navbar";
import {getKpiInfo} from "./api";
import cookiesService from "../../services/cookiesService";

const cookiesServiceInstance = cookiesService.getService();
export const SellerSide = () => {
  const classes = useNavStyles();
  const [kpiInfo, setKpiInfo] = useState({});

  const userData = cookiesServiceInstance.getUserData();
  const {position_code} = userData

  useEffect(() => {
    if (position_code === "SELLER")
      getKpiInfo().then(res => {
        setKpiInfo(res);
      });
  }, [position_code]);

  if (position_code !== "SELLER") return null

  return <Box className={classes.kpi_info}>
    {kpiInfo?.hunter_type_name ? (
      <Box className={classes.kpi_info_type}>
        <p>Тип:</p>
        <span>
          {kpiInfo.hunter_type_name}
          {kpiInfo?.is_streak_star ? (
            <Tooltip title={`Стабильность: план выполнен ${kpiInfo?.streak} мес. подряд`}>
              <StarIcon fontSize="small" style={{color: "#FFC107", verticalAlign: "middle", marginLeft: 4}}/>
            </Tooltip>
          ) : null}
        </span>
      </Box>
    ) : null}
    <Box className={classes.kpi_info_plan}>
      <p>План:</p>
      <span>
        <NumberFormat
          value={kpiInfo?.plan_sum}
          thousandSeparator={" "}
          displayType="text"
        />
      </span>
    </Box>
    <Box className={classes.kpi_info_percent}>
      <p>Процент:</p>
      <span>
                    <NumberFormat
                      value={kpiInfo?.percentage}
                      thousandSeparator={" "}
                      displayType="text"
                    />
                  </span>
    </Box>
    <Box className={classes.kpi_info_total}>
      <p>Общая сумма:</p>
      <span>
                    <NumberFormat
                      value={kpiInfo?.total}
                      thousandSeparator={" "}
                      displayType="text"
                    />
                  </span>
    </Box>
  </Box>
}
